(function () {
  'use strict';

  var app          = document.getElementById('gt-create-app');
  if (!app) return;

  var NETLIFY      = app.dataset.netlify;
  var STORE        = app.dataset.store;
  var CUSTOMER_ID  = app.dataset.customerId;

  // ── DOM refs ───────────────────────────────────────────────────────────
  var searchInput     = document.getElementById('gt-product-search');
  var resultsBox      = document.getElementById('gt-product-results');
  var selectedWrap    = document.getElementById('gt-selected-product-wrap');
  var searchWrap      = document.getElementById('gt-product-search-wrap');
  var selImg          = document.getElementById('gt-sel-img');
  var selName         = document.getElementById('gt-sel-name');
  var selPrice        = document.getElementById('gt-sel-price');
  var clearBtn        = document.getElementById('gt-clear-product');
  var optionChecks    = document.getElementById('gt-option-checkboxes');
  var noOptionsNote   = document.getElementById('gt-no-options-note');
  var formNameInput   = document.getElementById('gt-form-name');
  var deadlineInput   = document.getElementById('gt-deadline');
  var collectName     = document.getElementById('gt-collect-name');
  var collectEmail    = document.getElementById('gt-collect-email');
  var allowPartial    = document.getElementById('gt-allow-partial');
  var itemsList       = document.getElementById('gt-items-list');
  var addItemSearch   = document.getElementById('gt-add-item-search');
  var addItemResults  = document.getElementById('gt-add-item-results');
  var createBtn       = document.getElementById('gt-create-btn');
  var createMsg       = document.getElementById('gt-create-msg');
  var formWrap        = document.getElementById('gt-create-form-wrap');
  var resultPanel     = document.getElementById('gt-result-panel');
  var shareLink       = document.getElementById('gt-share-link');
  var copyBtn         = document.getElementById('gt-copy-btn');
  var draftLink       = document.getElementById('gt-draft-order-link');
  var submissionCount    = document.getElementById('gt-submission-count');
  var submissionsPanel   = document.getElementById('gt-submissions-panel');
  var submissionsList    = document.getElementById('gt-submissions-list');
  var addAllCartBtn      = document.getElementById('gt-add-all-cart');
  var cartMsg            = document.getElementById('gt-cart-msg');
  var newFormBtn         = document.getElementById('gt-new-form-btn');
  var currentFormId      = null;
  var currentSubmissions = [];

  var selectedProduct  = null;
  var allProducts      = [];
  var additionalItems  = []; // [{product, options[]}] for partial order

  // ── Org name combobox ──────────────────────────────────────────────────
  var GREEK_ORGS = [
    'Alpha Chi Omega','Alpha Delta Pi','Alpha Epsilon Phi','Alpha Gamma Delta',
    'Alpha Omicron Pi','Alpha Phi','Alpha Sigma Alpha','Alpha Sigma Tau',
    'Alpha Xi Delta','Chi Omega','Delta Delta Delta','Delta Gamma','Delta Phi Epsilon',
    'Delta Zeta','Gamma Phi Beta','Kappa Alpha Theta','Kappa Delta','Kappa Kappa Gamma',
    'Phi Mu','Phi Sigma Sigma','Pi Beta Phi','Sigma Delta Tau','Sigma Gamma Rho',
    'Sigma Kappa','Sigma Lambda Gamma','Theta Phi Alpha','Zeta Phi Beta','Zeta Tau Alpha',
    'Alpha Epsilon Pi','Alpha Phi Alpha','Alpha Tau Omega','Beta Theta Pi',
    'Chi Phi','Chi Psi','Delta Chi','Delta Kappa Epsilon','Delta Sigma Phi',
    'Delta Tau Delta','Delta Upsilon','Kappa Alpha Order','Kappa Alpha Psi',
    'Kappa Sigma','Lambda Chi Alpha','Omega Psi Phi','Phi Beta Sigma',
    'Phi Delta Theta','Phi Gamma Delta','Phi Kappa Psi','Phi Kappa Sigma',
    'Phi Kappa Tau','Phi Sigma Kappa','Pi Kappa Alpha','Pi Kappa Phi',
    'Pi Lambda Phi','Sigma Alpha Epsilon','Sigma Alpha Mu','Sigma Chi',
    'Sigma Nu','Sigma Phi Epsilon','Sigma Pi','Tau Kappa Epsilon',
    'Theta Chi','Theta Delta Chi','Zeta Beta Tau','Zeta Psi'
  ];

  (function initOrgCombo() {
    var inp  = document.getElementById('gt-org-name');
    var drop = document.getElementById('gt-org-name-drop');
    if (!inp || !drop) return;

    function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    function highlight(text, q) {
      if (!q) return document.createTextNode(text);
      var re = new RegExp('(' + escRe(q) + ')', 'gi');
      var frag = document.createDocumentFragment();
      text.split(re).forEach(function (p) {
        if (re.test(p)) { var m = document.createElement('mark'); m.style.cssText = 'background:transparent;font-weight:700;color:#950605'; m.textContent = p; frag.appendChild(m); }
        else frag.appendChild(document.createTextNode(p));
      });
      return frag;
    }

    function openDrop(q) {
      var matches = q ? GREEK_ORGS.filter(function (s) { return s.toLowerCase().includes(q.toLowerCase()); }) : GREEK_ORGS;
      drop.innerHTML = '';
      if (!matches.length) { drop.hidden = true; inp.setAttribute('aria-expanded','false'); return; }
      matches.forEach(function (item) {
        var li = document.createElement('li');
        li.setAttribute('role','option');
        li.style.cssText = 'padding:8px 12px;cursor:pointer;font-size:0.875rem';
        li.appendChild(highlight(item, q));
        li.addEventListener('mouseover', function () { li.style.background = '#f5f5f5'; });
        li.addEventListener('mouseout',  function () { li.style.background = ''; });
        li.addEventListener('mousedown', function (e) { e.preventDefault(); inp.value = item; drop.hidden = true; inp.setAttribute('aria-expanded','false'); });
        drop.appendChild(li);
      });
      drop.hidden = false;
      inp.setAttribute('aria-expanded','true');
    }

    inp.addEventListener('input',  function () { openDrop(inp.value.trim()); });
    inp.addEventListener('focus',  function () { openDrop(inp.value.trim()); });
    inp.addEventListener('blur',   function () { setTimeout(function () { drop.hidden = true; inp.setAttribute('aria-expanded','false'); }, 150); });
    inp.addEventListener('keydown', function (e) {
      if (drop.hidden) return;
      var lis = drop.querySelectorAll('li');
      var active = drop.querySelector('li[aria-selected="true"]');
      var idx = active ? Array.from(lis).indexOf(active) : -1;
      if (e.key === 'ArrowDown') { e.preventDefault(); if (active) active.removeAttribute('aria-selected'); var next = lis[Math.min(idx+1,lis.length-1)]; next.setAttribute('aria-selected','true'); next.scrollIntoView({block:'nearest'}); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (active) active.removeAttribute('aria-selected'); var prev = lis[Math.max(idx-1,0)]; prev.setAttribute('aria-selected','true'); prev.scrollIntoView({block:'nearest'}); }
      else if (e.key === 'Enter' && active) { e.preventDefault(); inp.value = active.textContent; drop.hidden = true; inp.setAttribute('aria-expanded','false'); }
      else if (e.key === 'Escape') { drop.hidden = true; inp.setAttribute('aria-expanded','false'); }
    });
  })();

  // ── Pre-fill from URL params immediately (no waiting for fetch) ─────────
  // When coming from a product page's "Start a Group Order" callout, the
  // handle + product data are embedded in the URL by group-order-callout.liquid.
  (function () {
    var params = new URLSearchParams(window.location.search);
    var handle = params.get('product_handle');
    var title  = params.get('pt');
    if (!handle || !title) return; // not coming from a product page callout
    var imgSrc  = params.get('pi');
    var price   = params.get('pp');
    var optsRaw = params.get('po');
    selectProduct({
      handle:   handle,
      title:    title,
      images:   imgSrc ? [{ src: imgSrc }] : [],
      variants: [{ price: price || '0.00' }],
      options:  optsRaw
        ? optsRaw.split('|').filter(Boolean).map(function (n) { return { name: n }; })
        : [],
    });
  })();

  // ── Load products via Shopify AJAX API ────────────────────────────────
  fetch('/products.json?limit=250')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      allProducts = data.products || [];
      // Pre-fill from URL params (from cart "Create bulk order form" button)
      var params = new URLSearchParams(window.location.search);
      // Support new multi-handle param: ?handles=handle1,handle2,...
      var handlesParam = params.get('handles');
      // Also support legacy single param: ?product_handle=handle (when no pt param — legacy path)
      var legacyHandle = !params.get('pt') ? params.get('product_handle') : null;
      var handleList = handlesParam
        ? handlesParam.split(',').map(function (h) { return h.trim(); }).filter(Boolean)
        : (legacyHandle ? [legacyHandle] : []);
      if (handleList.length > 0) {
        var firstMatch = allProducts.find(function (p) { return p.handle === handleList[0]; });
        if (firstMatch) {
          selectProduct(firstMatch); // upgrade with full product data from API
          // Push remaining handles as additional items
          for (var i = 1; i < handleList.length; i++) {
            (function (handle) {
              var m = allProducts.find(function (p) { return p.handle === handle; });
              if (m) { additionalItems.push({ product: m, options: [] }); }
            })(handleList[i]);
          }
          if (handleList.length > 1) renderItemsList();
        }
      }
    })
    .catch(function () { /* non-fatal */ });

  // ── Product search ────────────────────────────────────────────────────
  searchInput.addEventListener('input', function () {
    var q = this.value.trim().toLowerCase();
    if (q.length < 1) { closeResults(); return; }
    var matches = allProducts.filter(function (p) {
      return p.title.toLowerCase().indexOf(q) > -1;
    }).slice(0, 8);
    renderResults(matches);
  });

  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && !resultsBox.contains(e.target)) closeResults();
  });

  function renderResults(products) {
    resultsBox.innerHTML = '';
    if (!products.length) {
      resultsBox.innerHTML = '<div class="gt-product-option gt-muted">No products found</div>';
    } else {
      products.forEach(function (p) {
        var el = document.createElement('div');
        el.className = 'gt-product-option';
        el.setAttribute('role', 'option');
        var img = p.images && p.images[0] ? p.images[0].src : '';
        var price = p.variants && p.variants[0] ? formatPrice(p.variants[0].price) : '';
        el.innerHTML =
          (img ? '<img src="' + img + '" alt="" width="36" height="36">' : '') +
          '<div><div class="gt-product-option__name">' + esc(p.title) + '</div>' +
          (price ? '<div class="gt-product-option__price">' + price + '</div>' : '') +
          '</div>';
        el.addEventListener('mousedown', function (e) { e.preventDefault(); selectProduct(p); });
        resultsBox.appendChild(el);
      });
    }
    resultsBox.classList.add('is-open');
  }

  function closeResults() {
    resultsBox.classList.remove('is-open');
    resultsBox.innerHTML = '';
  }

  function selectProduct(p) {
    selectedProduct = p;
    closeResults();

    // Show selected pill
    var productUrl = '/products/' + p.handle;
    selImg.src = p.images && p.images[0] ? p.images[0].src : '';
    selImg.style.display = p.images && p.images[0] ? '' : 'none';
    var selImgLink = document.getElementById('gt-sel-img-link');
    if (selImgLink) selImgLink.href = productUrl;
    selName.textContent = p.title;
    selName.href = productUrl;
    selPrice.textContent = p.variants && p.variants[0] ? formatPrice(p.variants[0].price) : '';
    searchWrap.hidden = true;
    selectedWrap.hidden = false;

    // Build option checkboxes
    buildOptionCheckboxes(p.options || []);
    renderItemsList();
    checkReady();
  }

  function buildOptionCheckboxes(options) {
    optionChecks.innerHTML = '';
    // Filter out boring default option
    var real = options.filter(function (o) { return o.name !== 'Title'; });
    if (!real.length) {
      noOptionsNote.hidden = false;
      return;
    }
    noOptionsNote.hidden = true;
    real.forEach(function (opt) {
      var label = document.createElement('label');
      label.className = 'gt-option-check';
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.value = opt.name;
      cb.checked = true;
      cb.addEventListener('change', function () {
        label.classList.toggle('is-checked', this.checked);
      });
      label.classList.add('is-checked');
      label.appendChild(cb);
      label.appendChild(document.createTextNode(' ' + opt.name));
      optionChecks.appendChild(label);
    });
  }

  clearBtn.addEventListener('click', function () {
    selectedProduct = null;
    searchWrap.hidden = false;
    selectedWrap.hidden = true;
    searchInput.value = '';
    optionChecks.innerHTML = '';
    noOptionsNote.hidden = true;
    checkReady();
  });

  function renderItemsList() {
    if (!itemsList) return;
    itemsList.innerHTML = '';

    additionalItems.forEach(function (entry, idx) {
      var p = entry.product;
      var img = p.images && p.images[0];

      var wrap = document.createElement('div');
      wrap.className = 'gt-item-row gt-item-row--card';

      // Header: image + name + remove
      var productUrl = '/products/' + p.handle;
      var header = document.createElement('div');
      header.className = 'gt-item-row__header';
      if (img) {
        var imgLink = document.createElement('a');
        imgLink.href = productUrl; imgLink.target = '_blank'; imgLink.className = 'gt-selected-product__img-link';
        var imgEl = document.createElement('img');
        imgEl.src = img.src || img; imgEl.width = 36; imgEl.height = 36; imgEl.alt = '';
        imgLink.appendChild(imgEl);
        header.appendChild(imgLink);
      }
      var nameEl = document.createElement('a');
      nameEl.className = 'gt-item-row__name';
      nameEl.href = productUrl; nameEl.target = '_blank';
      nameEl.textContent = p.title;
      header.appendChild(nameEl);

      var removeBtn = document.createElement('button');
      removeBtn.className = 'gt-item-row__remove';
      removeBtn.type = 'button';
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.textContent = '✕';
      removeBtn.addEventListener('click', function () {
        additionalItems.splice(idx, 1);
        renderItemsList();
      });
      header.appendChild(removeBtn);
      wrap.appendChild(header);

      // Per-product option checkboxes
      var realOpts = (p.options || []).filter(function (o) { return o.name !== 'Title'; });
      if (realOpts.length) {
        var optsWrap = document.createElement('div');
        optsWrap.className = 'gt-item-row__opts';

        var optsLabel = document.createElement('p');
        optsLabel.className = 'gt-label';
        optsLabel.textContent = 'Options members can customize:';
        optsWrap.appendChild(optsLabel);

        var grid = document.createElement('div');
        grid.className = 'gt-option-grid';
        realOpts.forEach(function (opt) {
          var lbl = document.createElement('label');
          lbl.className = 'gt-option-check is-checked';
          var cb = document.createElement('input');
          cb.type = 'checkbox';
          cb.value = opt.name;
          cb.checked = true;
          cb.addEventListener('change', function () {
            lbl.classList.toggle('is-checked', this.checked);
            entry.options = getCheckedOptionsFor(grid);
          });
          lbl.appendChild(cb);
          lbl.appendChild(document.createTextNode(' ' + opt.name));
          grid.appendChild(lbl);
        });
        entry.options = realOpts.map(function (o) { return o.name; }); // default all checked
        optsWrap.appendChild(grid);
        wrap.appendChild(optsWrap);
      } else {
        entry.options = [];
      }

      itemsList.appendChild(wrap);
    });
  }

  function getCheckedOptionsFor(grid) {
    return Array.from(grid.querySelectorAll('input:checked')).map(function (cb) { return cb.value; });
  }

  // ── Add-item search ───────────────────────────────────────────────────
  if (addItemSearch) {
    addItemSearch.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      if (q.length < 1) { addItemResults.classList.remove('is-open'); addItemResults.innerHTML = ''; return; }
      var matches = allProducts.filter(function (p) {
        return p.title.toLowerCase().indexOf(q) > -1;
      }).slice(0, 8);
      addItemResults.innerHTML = '';
      if (!matches.length) {
        addItemResults.innerHTML = '<div class="gt-product-option gt-muted">No products found</div>';
      } else {
        matches.forEach(function (p) {
          var el = document.createElement('div');
          el.className = 'gt-product-option';
          var img = p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '';
          el.innerHTML = (img ? '<img src="' + img + '" alt="" width="36" height="36">' : '') +
            '<div><div class="gt-product-option__name">' + esc(p.title) + '</div></div>';
          el.addEventListener('mousedown', function (e) {
            e.preventDefault();
            additionalItems.push({ product: p, options: [] });
            addItemSearch.value = '';
            addItemResults.classList.remove('is-open');
            addItemResults.innerHTML = '';
            renderItemsList();
          });
          addItemResults.appendChild(el);
        });
      }
      addItemResults.classList.add('is-open');
    });

    document.addEventListener('click', function (e) {
      if (!addItemSearch.contains(e.target) && !addItemResults.contains(e.target)) {
        addItemResults.classList.remove('is-open');
        addItemResults.innerHTML = '';
      }
    });
  }

  // ── Enable create button when product + name are set ─────────────────
  formNameInput.addEventListener('input', checkReady);
  function checkReady() {
    createBtn.disabled = !(selectedProduct && formNameInput.value.trim());
  }

  // ── Create form ───────────────────────────────────────────────────────
  createBtn.addEventListener('click', function () {
    if (!NETLIFY) {
      showMsg(createMsg, 'error', 'Please set your Netlify URL in Theme Settings → GreekThreads.');
      return;
    }

    var checkedOptions = Array.from(optionChecks.querySelectorAll('input:checked')).map(function (cb) { return cb.value; });

    // Build items array (first product + any additional items, each with their own options)
    var firstImg = selectedProduct.images && selectedProduct.images[0];
    var items = [{ product_handle: selectedProduct.handle, product_title: selectedProduct.title, product_image: firstImg ? (firstImg.src || firstImg) : '', options: checkedOptions }];
    additionalItems.forEach(function (entry) {
      var img = entry.product.images && entry.product.images[0];
      items.push({ product_handle: entry.product.handle, product_title: entry.product.title, product_image: img ? (img.src || img) : '', options: entry.options || [] });
    });

    createBtn.classList.add('is-loading');
    createBtn.disabled = true;
    createMsg.className = 'gt-msg';

    fetch(NETLIFY + '/create-bulk-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        form_name:            formNameInput.value.trim(),
        org_name:             (document.getElementById('gt-org-name') || {}).value || '',
        product_handle:       selectedProduct.handle,
        product_title:        selectedProduct.title,
        product_image:        firstImg ? (firstImg.src || firstImg) : '',
        options:              checkedOptions,
        items:                items,
        allow_partial_order:  allowPartial.checked,
        deadline:             deadlineInput.value || '',
        collect_name:         collectName.checked,
        collect_email:        collectEmail.checked,
        creator_customer_id:  CUSTOMER_ID
      })
    })
    .then(function (r) { if (!r.ok) throw new Error('Server error ' + r.status); return r.json(); })
    .then(function (data) {
      if (!data.success) throw new Error(data.error || 'Could not create form.');
      currentFormId = data.form_id;
      var url = 'https://' + STORE + '/pages/bulk-order?id=' + data.form_id;
      shareLink.value = url;
      draftLink.hidden = true;
      formWrap.hidden = true;
      resultPanel.hidden = false;
      submissionsPanel.hidden = false;
      // Start polling for submissions every 15s
      pollSubmissions();
      setInterval(pollSubmissions, 15000);
    })
    .catch(function (err) {
      showMsg(createMsg, 'error', err.message || 'Something went wrong.');
      createBtn.classList.remove('is-loading');
      createBtn.disabled = false;
    });
  });

  // ── Copy link ─────────────────────────────────────────────────────────
  copyBtn.addEventListener('click', function () {
    shareLink.select();
    try {
      navigator.clipboard.writeText(shareLink.value);
    } catch (e) {
      document.execCommand('copy');
    }
    copyBtn.textContent = 'Copied!';
    copyBtn.classList.add('copied');
    setTimeout(function () { copyBtn.textContent = 'Copy link'; copyBtn.classList.remove('copied'); }, 2200);
  });

  // ── Poll submissions ──────────────────────────────────────────────────
  function pollSubmissions() {
    if (!currentFormId || !NETLIFY) return;
    fetch(NETLIFY + '/get-submissions?id=' + currentFormId)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.success) return;
        currentSubmissions = data.submissions || [];
        renderSubmissions(currentSubmissions);
        var count = currentSubmissions.length;
        submissionCount.textContent = count + ' submission' + (count !== 1 ? 's' : '');
      })
      .catch(function () { /* silent */ });
  }

  function renderSubmissions(subs) {
    if (!subs.length) {
      submissionsList.innerHTML = '<p class="gt-muted gt-form-note">No submissions yet. Share the link above!</p>';
      addAllCartBtn.hidden = true;
      return;
    }

    var rows = subs.map(function (s) {
      var detail = '';
      if (s.items && s.items.length) {
        // Partial order: show each item
        detail = s.items.map(function (it) {
          var opts = (it.properties || [])
            .filter(function (p) { return !p.name.startsWith('_') && p.name !== 'Member Name' && p.name !== 'Member Email'; })
            .map(function (p) { return esc(p.name) + ': ' + esc(p.value); })
            .join(', ');
          return '<span class="gt-option-tag">' + esc(it.product_title || it.product_handle) + (opts ? ' · ' + opts : '') + '</span>';
        }).join(' ');
      } else {
        detail = (s.properties || [])
          .filter(function (p) { return !p.name.startsWith('_') && p.name !== 'Member Name' && p.name !== 'Member Email'; })
          .map(function (p) { return '<span class="gt-option-tag">' + esc(p.name) + ': ' + esc(p.value) + '</span>'; })
          .join(' ');
      }
      return '<div class="gt-sub-row">' +
        '<span class="gt-sub-row__name">' + esc(s.member_name) + '</span>' +
        '<span class="gt-sub-row__opts">' + detail + '</span>' +
        '</div>';
    }).join('');

    submissionsList.innerHTML = rows;
    addAllCartBtn.hidden = false;
  }

  // ── Add all to cart ───────────────────────────────────────────────────
  addAllCartBtn.addEventListener('click', function () {
    if (!currentSubmissions.length) return;

    addAllCartBtn.classList.add('is-loading');
    addAllCartBtn.disabled = true;
    cartMsg.hidden = true;

    // Build items array for Shopify cart/add.js (handles both single and partial-order format)
    var items = [];
    currentSubmissions.forEach(function (s) {
      if (s.items && s.items.length) {
        s.items.forEach(function (it) {
          if (!it.variant_id) return;
          var cartItem = { id: it.variant_id, quantity: it.quantity || 1 };
          if (it.properties && it.properties.length) {
            cartItem.properties = {};
            it.properties.forEach(function (p) { if (!p.name.startsWith('_')) cartItem.properties[p.name] = p.value; });
          }
          items.push(cartItem);
        });
      } else if (s.variant_id) {
        var cartItem = { id: s.variant_id, quantity: s.quantity || 1 };
        if (s.properties && s.properties.length) {
          cartItem.properties = {};
          s.properties.forEach(function (p) { if (!p.name.startsWith('_')) cartItem.properties[p.name] = p.value; });
        }
        items.push(cartItem);
      }
    });

    if (!items.length) {
      addAllCartBtn.classList.remove('is-loading');
      addAllCartBtn.disabled = false;
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
    .then(function () {
      addAllCartBtn.classList.remove('is-loading');
      addAllCartBtn.disabled = false;
      cartMsg.hidden = false;
      setTimeout(function () { window.location.href = '/cart'; }, 1500);
    })
    .catch(function () {
      addAllCartBtn.classList.remove('is-loading');
      addAllCartBtn.disabled = false;
      showMsg(createMsg, 'error', 'Could not add to cart. Please try again.');
    });
  });

  // ── New form ──────────────────────────────────────────────────────────
  newFormBtn.addEventListener('click', function () {
    selectedProduct = null;
    additionalItems = [];
    searchWrap.hidden = false;
    selectedWrap.hidden = true;
    searchInput.value = '';
    formNameInput.value = '';
    var orgInp = document.getElementById('gt-org-name'); if (orgInp) orgInp.value = '';
    deadlineInput.value = '';
    optionChecks.innerHTML = '';
    allowPartial.checked = false;
    if (itemsList) itemsList.innerHTML = '';
    createBtn.disabled = true;
    createBtn.classList.remove('is-loading');
    createMsg.className = 'gt-msg';
    resultPanel.hidden = true;
    formWrap.hidden = false;
  });

  // ── Helpers ───────────────────────────────────────────────────────────
  function formatPrice(price) {
    if (!price) return '';
    return '$' + parseFloat(price).toFixed(2);
  }

  function showMsg(el, type, msg) {
    el.textContent = msg;
    el.className = 'gt-msg gt-msg--' + type;
  }

  function esc(str) {
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
})();
